(async () => {
  const leafletInterval = setInterval(() => {
    if (typeof L !== "undefined") {
      clearInterval(leafletInterval);
      const map = L.map("map").setView(
        [47.84873687126748, -122.29287966061928],
        16
      );
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        maxZoom: 19,
        attribution: "© OpenStreetMap contributors",
      }).addTo(map);
      const marker = L.marker([47.84873687126748, -122.29287966061928]).addTo(
        map
      );
      marker
        .bindPopup(
          "<b>The Truckmount Guys</b><br>16513 Hwy 99, Lynnwood, WA 98037"
        )
        .openPopup();
      map.scrollWheelZoom.disable();
      map.touchZoom.disable();
      map.doubleClickZoom.disable();
      map.boxZoom.disable();
      map.keyboard.disable();
      map.dragging.disable();
      map.zoomControl.remove();
    }
  }, 500);
})();
